<template>
  <div>
    <app-title>Review Clawbacks</app-title>

    <v-card>
      <commission-detail detail-type="clawback" :selected="selected" @setClawback="setClawBacks"></commission-detail>
      <ag-grid-vue
        style="width: 100%; height: 500px;"
        class="ag-theme-balham"
        :columnDefs="headers"
        :rowData="clawbacks"
        :gridOptions="gridOptions"
        :defaultColDef="defaultColDef"
        rowSelection="multiple"
        :supressRowClickSelection="true"
        @first-data-rendered="onFirstDataRendered"
        @selection-changed="onSelectionChanged"
        ref="grid"
        rowMultiSelectWithClick
        enableCellTextSelection
      ></ag-grid-vue>
    </v-card>
  </div>
</template>
<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import commissionDetail from "@/components/commissions/commissionDetail";
import { AgGridVue } from "ag-grid-vue";
import { mapActions, mapState } from "vuex";
export default {
  name: "ManageClawbacks",
  components: {
    AgGridVue,
    commissionDetail,
  },
  data() {
    return {
      gridOptions: {},
      defaultColDef: { resizeable: true, sortable: true },
      runs: 400,
      loading: false,
      search: "",
      currentRow: undefined,
      clawbacks: [],
      selected: [],
      headers: [
        {
          headerName: "Dealer",
          field: "dealerID",
          sortable: true,
          filter: "agNumberColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
        },
        {
          headerName: "Comms Total",
          field: "totalRunPayment",
          sortable: true,
          filter: "agNumberColumnFilter",
          valueFormatter: this.currencyFormatter,
        },
        {
          headerName: "Customer Number",
          field: "custNo",
          sortable: true,
          filter: "agNumberColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
        },
        {
          headerName: "CSN",
          field: "csn",
          sortable: true,
          filter: "agTextColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
        },
        {
          headerName: "Rate Plan",
          field: "ratePlanDescription",
          sortable: true,
          filter: "agTextColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
        },
        {
          headerName: "Date Added",
          field: "serviceDateAdded",
          sortable: true,
          filter: "agDateColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
          valueFormatter: this.dateFormatter,
        },
        {
          headerName: "Date Disconnected",
          field: "dateDisconnected",
          sortable: true,
          filter: "agDateColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
          valueFormatter: this.dateFormatter,
        },
        {
          headerName: "Run Paid",
          field: "runIDPaid",
          sortable: true,
          filter: "agNumberColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
        },
        {
          headerName: "Date Paid",
          field: "datePaid",
          sortable: true,
          filter: "agDateColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
          valueFormatter: this.dateFormatter,
        },
        {
          headerName: "Amount Paid",
          field: "amount",
          sortable: true,
          filter: "agNumberColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
          valueFormatter: this.currencyFormatter,
        },
        {
          headerName: "Months Diff",
          field: "monthsDiff",
          sortable: true,
          filter: "agNumberColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
        },
        {
          headerName: "Amount to Clawback",
          field: "clawbackAmount",
          sortable: true,
          valueFormatter: this.currencyFormatter,
        },
      ],
    };
  },
  computed: {
    ...mapState("commissions", ["run"]),
  },
  methods: {
    ...mapActions("clawBacks", ["getClawBacks", "commitClawBacks"]),
    ...mapActions("message", ["setMessage"]),
    collectClawBacks() {
      let vm = this;
      return new Promise((resolve, reject) => {
        vm.gridOptions.api.showLoadingOverlay();
        if (!vm.run && !vm.run.runId) {
          resolve();
          return;
        }
        vm.getClawBacks(vm.run.runId)
          .then((result) => {
            vm.clawbacks = result;
            vm.gridOptions.api.hideOverlay();
            resolve(result);
          })
          .catch((err) => {
            vm.gridOptions.api.hideOverlay();
            reject(err);
          });
      });
    },
    setClawBacks() {
      let vm = this;
      let selected = vm.gridOptions.api.getSelectedRows();
      vm.commitClawBacks(selected).then((result) => {
        if (result.some((x) => x.comment == "Has already been applied"))
          vm.setMessage(
            new {
              message: "Clawback has already been applied",
              httpStatus: 500,
            }(),
            { root: true }
          );
        vm.$emit("clawbacksApplied", vm.run);
      });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.substring(0, 10).split("-");
      return `${day}/${month}/${year}`;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onSelectionChanged() {
      this.selected = this.gridOptions.api.getSelectedRows();
    },
  },
  mounted() {
    //this.collectClawBacks();
  },
};
</script>
